import { FormModel } from "../../../utils/FormModel";
import { SystemAlert } from "../../system/models/SystemAlert";

export class StatusRecord extends FormModel {
    public sid: string = "";
    public health: string = "";
    public alerts: SystemAlert[] = [];
    public dateCreated: Date = new Date();
}